import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { useApp } from "../context/AppContext";
import { isNativeApp } from "../lib/appVersion";
import { checkLiveUpdate, getLiveUpdateInfo, subscribeLiveUpdate } from "../lib/liveUpdate";
import { hapticTick, hapticSelect } from "../lib/haptics";

// Native only (under the build id in "More"): which web bundle runs + a manual "check now".
export const LiveUpdateStatus = () => {
  const { t } = useApp();
  const [info, setInfo] = useState(null);
  const [live, setLive] = useState(null);
  useEffect(() => subscribeLiveUpdate(setLive), []);
  useEffect(() => { if (isNativeApp()) getLiveUpdateInfo().then(setInfo); }, [live?.state]);
  if (!isNativeApp()) return null;
  const run = async () => {
    const r = await checkLiveUpdate({ applyNow: true });
    const mine = (r?.version || info?.web || "").slice(0, 8) || "?";
    const srv = (r?.server || "").slice(0, 8) || "?";
    if (r?.state === "busy") toast.info(t("live_update_checking"));
    else if (r?.state === "idle" && r?.reason) toast.error(`${t("live_update_failed")}: ${r.reason} · ${t("live_update_server")} ${srv}`, { duration: 15000 });
    else if (r?.state === "idle") toast.success(`${t("live_update_uptodate")} · web ${mine} = ${t("live_update_server")} ${srv}`);
    else if (r?.state === "error") toast.error(`${t("live_update_failed")}: ${r.reason || ""}`);
  };
  const busy = ["checking", "downloading", "applying"].includes(live?.state);
  return (
    <div className="text-center text-[11px] text-muted-foreground mb-6 space-y-2" data-testid="live-update-status">
      <p data-testid="live-update-web-version">
        Web {info?.web ? info.web.slice(0, 8) : "—"} · {info?.bundle?.version && info.bundle.version !== "builtin" ? t("live_update_ota") : t("live_update_builtin")}
        {info?.pluginError ? ` · ${t("live_update_no_plugin")}` : ""}
      </p>
      {info && !info.web && info.debug ? <p className="break-all opacity-70" data-testid="live-update-debug">{info.debug}</p> : null}
      <Button size="sm" variant="outline" className="h-8 text-xs" onClick={run} disabled={busy} data-testid="live-update-check-btn">
        <RefreshCw className={`h-3.5 w-3.5 mr-1 ${busy ? "animate-spin" : ""}`} />
        {busy ? t(`live_update_${live.state}`) : t("live_update_check")}
      </Button>
      {/* haptics self-test: tells whether the phone honours UIFeedbackGenerator (System Haptics) or only the raw motor */}
      <div className="flex justify-center gap-2" data-testid="haptics-test">
        <Button size="sm" variant="ghost" className="h-7 text-[11px]" data-testid="haptics-test-impact"
                onClick={async () => { try { await hapticTick("start"); toast.success("tick OK"); } catch (e) { toast.error(`tick: ${e?.message || e}`); } }}>
          Testar vibração 1
        </Button>
        <Button size="sm" variant="ghost" className="h-7 text-[11px]" data-testid="haptics-test-vibrate"
                onClick={async () => { try { await hapticSelect(); toast.success("select OK"); } catch (e) { toast.error(`select: ${e?.message || e}`); } }}>
          Testar vibração 2
        </Button>
      </div>
    </div>
  );
};
